const BRAND_ALIASES = {
  BH1: "BHX",
  BH2: "BHX",
};

const BRAND_GROUPS = {
  consentMode: ["BHX", "BFS"],
  commerceEvents: ["AIR", "BHX", "BFS"],
  resultsViewItemList: ["BHX", "BFS"],
  loungeSearch: ["NWI", "BHX", "BFS"],
  checkoutEvents: ["BHX", "BFS"],
  confirmationPurchase: ["AIR", "BHX", "BFS"],
};

export function normalizeGtmBrand(brand) {
  return BRAND_ALIASES[brand] || brand;
}

export function brandUsesConsentMode(brand) {
  return BRAND_GROUPS.consentMode.includes(normalizeGtmBrand(brand));
}

export function brandSupportsCommerceEvents(brand) {
  return BRAND_GROUPS.commerceEvents.includes(normalizeGtmBrand(brand));
}

export function brandSupportsResultsViewItemList(brand) {
  return BRAND_GROUPS.resultsViewItemList.includes(normalizeGtmBrand(brand));
}

export function brandSupportsLoungeSearch(brand) {
  return BRAND_GROUPS.loungeSearch.includes(normalizeGtmBrand(brand));
}

export function brandSupportsCheckoutEvents(brand) {
  return BRAND_GROUPS.checkoutEvents.includes(normalizeGtmBrand(brand));
}

export function brandSupportsConfirmationPurchase(brand) {
  return BRAND_GROUPS.confirmationPurchase.includes(normalizeGtmBrand(brand));
}
